import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { IoDuplicate } from 'react-icons/io5'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, GrupoTrib, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'

import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { Link, useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { TributacaoService } from '../../Pages/Tributacao/TributacaoService'
import { FaCopy, FaTrashAlt } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import moment from 'moment'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    tributacao: GrupoTrib[],
    handleUpdateTributacaoList: () => void,
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number
    descricao: string
    pICMS: string
    pPIS: string
    pCOFINS: string
    cstPisCofins: string
    cfopSDentro: string
    cfopSFora: string
    cfopEdentro: string
    cfopEfora: string
    cstICMSDentro: string
    cstICMSFora: string
    dt_cadastro: string
}

export const GridTributacao = React.memo(({ tributacao, handleUpdateTributacaoList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_trib")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_trib") || '')
                : {
                    acao: true,
                    descricao: true,
                    pICMS: true,
                    pPIS: true,
                    pCOFINS: true,
                    cstPisCofins: false,
                    cfopSDentro: false,
                    cfopSFora: false,
                    cfopEdentro: false,
                    cfopEfora: false,
                    cstICMSDentro: false,
                    cstICMSFora: false,
                    dt_cadastro: true,
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_trib")

    let json: any = {
        acao: true,
        descricao: true,
        pICMS: true,
        pPIS: true,
        pCOFINS: true,
        cstPisCofins: false,
        cfopSDentro: false,
        cfopSFora: false,
        cfopEdentro: false,
        cfopEfora: false,
        cstICMSDentro: false,
        cstICMSFora: false,
        dt_cadastro: true,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_trib") || '')
    }
        */

    const [idTrib, setIdTrib] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [tributacoes, setTributacoes] = useState<GrupoTrib[]>([])
    const [nomeTrib, setNomeTrib] = useState("")

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setTributacoes(tributacao)
    }, [tributacao])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_trib", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await TributacaoService.Delete(idTrib, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Tributação excluída com sucesso`)

                handleUpdateTributacaoList()

                //setTributacoes(await TributacaoService.Filter('', '', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a tributação. Por favor, tente novamente`)

        }

    }, [idTrib])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_tributo")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeTrib("")
        }

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeTrib("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- CODIGO SEM USO --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    /*
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.acao = json.acao
                newColumnVisibility.descricao = json.descricao
                newColumnVisibility.pICMS = json.pICMS
                newColumnVisibility.pPIS = json.pPIS
                newColumnVisibility.pCOFINS = json.pCOFINS
                newColumnVisibility.cstPisCofins = json.cstPisCofins
                newColumnVisibility.cfopSDentro = json.cfopSDentro
                newColumnVisibility.cfopSFora = json.cfopSFora
                newColumnVisibility.cfopEdentro = json.cfopEdentro
                newColumnVisibility.cfopEfora = json.cfopEfora
                newColumnVisibility.cstICMSDentro = json.cstICMSDentro
                newColumnVisibility.cstICMSFora = json.cstICMSFora
                newColumnVisibility.dt_cadastro = json.dt_cadastro
            }
        }

    }, [])
    */


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaTribEdit = (id: number) => {
        navigate(`/tributacao/edit/${id}`)
    }

    const navegarTelaTribDupli = (id: number) => {
        navigate(`/tributacao/dupli/${id}`)
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const colunas = useMemo<MRT_ColumnDef<GrupoTrib>[]>(() => [

        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: false, enableSorting: false, size: 170, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                const navegacaoDupli = () => {
                    navegarTelaTribDupli(rowData.id)
                }

                const navegacaoEdit = () => {
                    navegarTelaTribEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {
                        setIdTrib(rowData.id)
                        setNomeTrib(rowData.descricao)
                        setModalShow(true)
    
                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }
    
                        let menuFiltro = document.getElementById("divMenuFiltroTrib") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsTrib") as HTMLDivElement
    
                        if (menuFiltro) {
    
                            menuInputs.classList.add("invisible")
    
                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[390px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                Inputfocus()
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0);

                }

                return (
                    <div className={`flex justify-start w-full`}>

                        <button
                            onClick={navegacaoDupli} data-tooltip-id={'tooltip-duplicar-' + rowData.id} id={'btn-duplicar-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-slate-700 w-[30px] h-[30px] rounded-md 
                                      bg-slate-400`}>
                            <IoDuplicate size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(148, 163, 184)' }} id={'tooltip-duplicar-' + rowData.id} anchorSelect={'#btn-duplicar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                <span>Duplicar</span>
                            </Tooltip>

                        </button>

                        <button
                            onClick={navegacaoEdit} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                      bg-sky-500 ml-2`}>
                            <RiEdit2Fill size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed"  >
                                <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                            </Tooltip>

                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                      bg-red-500 ml-2`} >
                            <FaTrashAlt size="18px" />

                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top-end'  >
                                <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                            </Tooltip>

                        </button>
                    </div>
                )
            }
        },

        {
            accessorKey: 'descricao', visibleInShowHideMenu: true, header: 'Descrição', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span className={`break-all`}>{rowData.descricao ? rowData.descricao : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'pICMS', visibleInShowHideMenu: true, header: 'pICMS', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.pICMS ? rowData.pICMS : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'pPIS', visibleInShowHideMenu: true, header: 'pPIS', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.pPIS ? rowData.pPIS : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'pCOFINS', visibleInShowHideMenu: true, header: 'pCOFINS', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.pCOFINS ? rowData.pCOFINS : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cstPisCofins', visibleInShowHideMenu: true, header: 'Cst pCofins', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cstPisCofins ? rowData.cstPisCofins : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfopSDentro', visibleInShowHideMenu: true, header: 'Cfop Saida Dentro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfopSDentro ? rowData.cfopSDentro : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfopSFora', visibleInShowHideMenu: true, header: 'Cfop Saida Fora', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfopSFora ? rowData.cfopSFora : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfopEdentro', visibleInShowHideMenu: true, header: 'Cfop Entrada Dentro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfopEdentro ? rowData.cfopEdentro : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfopEfora', visibleInShowHideMenu: true, header: 'Cfop Entrada Fora', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfopEfora ? rowData.cfopEfora : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cstICMSDentro', visibleInShowHideMenu: true, header: 'Cst ICMS Dentro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cstICMSDentro ? rowData.cstICMSDentro : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cstICMSFora', visibleInShowHideMenu: true, header: 'Cst ICMS Fora', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cstICMSFora ? rowData.cstICMSFora : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

            }
        }

    ], [])

    const table = useMaterialReactTable({
        columns: colunas,
        data: tributacoes,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (

        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a tributação - ${nomeTrib || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})